import React from 'react';
import { Table } from 'react-bootstrap';

/**
 * SkippedUsersTable component displays a table of users that were skipped during import.
 * @component
 * @param {Object[]} skippedUsers - Array of skipped user objects.
 * @param {number} skippedUsers[].row - The row number in the Excel file where the user was skipped.
 * @param {string} skippedUsers[].email - The email address of the skipped user.
 * @param {string} skippedUsers[].reason - The reason why the user was skipped.
 * @returns {JSX.Element|null} A table of skipped users, or null if there are no skipped users.
 */

const SkippedUsersTable = ({ skippedUsers }) => {
  if (!skippedUsers || skippedUsers.length === 0) return null;

  return (
    <div className="mb-3">
      <h6 className="text-warning">Skipped Users</h6>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Row</th>
            <th>Email</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>
          {skippedUsers.map((skipped, index) => (
            <tr key={index}>
              <td>{skipped.row}</td>
              <td>{skipped.email}</td>
              <td>{skipped.reason}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SkippedUsersTable;
